<template>
    <div>
        <vs-sidebar
            click-not-close
            hidden-background
            position-right
            v-model="active"
            class="activity-sidebar items-no-padding">
            <div class="m-3 h-full main">
                <div class="mb-base">
                    <div class="flex justify-between">
                        <div class="activity-heading">
                            <h4>Activity</h4>
                        </div>
                        <feather-icon 
                            icon="XIcon" 
                            class="cursor-pointer" 
                            @click.stop="closeActivitySidebar"
                        />
                    </div>
                </div>
                <div v-show="fetchingActivityLog" id="div-activity-with-loading" class="vs-con-loading__container" style="min-height: 50px;"></div>
                <timeline :activityLogData="activityLogData" />
            </div>
        </vs-sidebar>
    </div>
</template>

<script>
import Timeline from '../Activity/components/Timeline.vue';

export default {
    props: {
        active: {
            type: Boolean,
            required: true,
            default: false
        },
        activityLogData: {
            type: Array,
            required: true,
            default: () => { return []; }
        },
        fetchingActivityLog: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    components: { Timeline },
    watch: {
        fetchingActivityLog(val) {
            if(val === true) {
                this.$vs.loading({
                    container: '#div-activity-with-loading',
                    scale: 0.5
                });
            } else {
                this.$vs.loading.close('#div-activity-with-loading > .con-vs-loading');
            }
        }
    },
    methods: {
        closeActivitySidebar() {
            this.$emit('closeActivitySidebar');
        }
    }
}
</script>

<style scoped>
.activity-sidebar >>> .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 400px!important;
    max-width: 90vw!important;
    box-shadow: 0 15px 30px 0 rgba(0,0,0,0.11), 0 5px 15px 0 rgba(0,0,0,0.08);
    white-space: normal!important;
}

.activity-sidebar >>> .main {
    overflow-y: scroll;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
.activity-sidebar >>> .main::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}

.activity-heading h4 {
    font-size: 18.48px!important;
}
</style>